import React from "react";
import { Link } from "react-router-dom";

function Publications() {
return (
<main className="homepage publications-page public-section-landing">
<h1>Publications</h1>

  <p style={{ textAlign: "center", marginBottom: "40px", color: "#666" }}>
    Explore books, newspaper archives, and conference magazine editions.
  </p>

    <div className="article-category-grid">

    {/* BOOKS */}
    <Link
      to="/publications/books"
      style={{ textDecoration: "none", color: "inherit" }}
    >
          <div className="publication-category-card">
        <div className="landing-category-icon" aria-hidden="true">
  📚
</div>
        <h2 style={{ marginBottom: "12px" }}>Books</h2>
        <p style={{ color: "#666", lineHeight: "1.6" }}>
          Search books by title or author and read the uploaded PDF editions.
        </p>
      </div>
    </Link>

    {/* NEWSPAPERS */}
    <Link
      to="/publications/newspapers"
      style={{ textDecoration: "none", color: "inherit" }}
    >
          <div className="publication-category-card">
        <div className="landing-category-icon" aria-hidden="true">
  📰
</div>
        <h2 style={{ marginBottom: "12px" }}>Newspapers</h2>
        <p style={{ color: "#666", lineHeight: "1.6" }}>
          Browse the monthly archive of <strong>ছাত্র সংবাদ</strong> by year and issue.
        </p>
      </div>
    </Link>

    {/* MAGAZINES */}
    <Link
      to="/publications/magazines"
      style={{ textDecoration: "none", color: "inherit" }}
    >
          <div className="publication-category-card">
        <div className="landing-category-icon" aria-hidden="true">
  📖
</div>
        <h2 style={{ marginBottom: "12px" }}>Magazines</h2>
        <p style={{ color: "#666", lineHeight: "1.6" }}>
          Access annual conference editions and special magazine publications.
        </p>
      </div>
    </Link>

    </div>
</main>


);
}

export default Publications;
